<section class="mx-auto w-full px-4 py-10 md:pt-22.5 md:pb-27">
  @if (isLoading()) {
    <div
      class="flex h-[60vh] items-center justify-center bg-white-light px-6 py-10 text-center"
    >
      <app-empty-page
        [imageSrc]="'/assets/images/Pending.svg'"
        [message]="'We Are Checking Your Payment Status'"
      />
    </div>
  } @else {
    <app-payment-status-banner
      [imageSrc]="banner().imageSrc"
      [title]="banner().title"
      [message]="banner().message"
      [buttonText]="banner().buttonText"
      [buttonLink]="banner().buttonLink"
      [secondaryButtonText]="banner().secondaryButtonText"
      [secondaryButtonLink]="banner().secondaryButtonLink"
      (primaryAction)="handlePrimaryAction($event)"
    />
  }
</section>
